import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const cookieUser = Cookies.get("user");
    if (cookieUser) {
      setUser(JSON.parse(cookieUser));
    } else {
      navigate("/login");
    }
  }, [navigate]);

  if (!user) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-semibold text-gray-800 mb-6">Profile</h1>

      <div className="bg-white rounded-2xl shadow-lg p-8">
        <div className="flex flex-col md:flex-row gap-8 items-start">
          <div className="flex-shrink-0 mx-auto md:mx-0">
            <img
              src={user.image_url}
              alt={user.name}
              className="h-28 w-28 rounded-full object-cover border"
            />
          </div>

          <div className="flex-1 w-full text-sm text-gray-700 space-y-3">
            <div className="flex">
              <span className="w-32 font-medium">ID</span>
              <span>:</span>
              <span className="ml-2">{user.id}</span>
            </div>

            <div className="flex">
              <span className="w-32 font-medium">Nama Lengkap</span>
              <span>:</span>
              <span className="ml-2">{user.name}</span>
            </div>

            <div className="flex">
              <span className="w-32 font-medium">Email</span>
              <span>:</span>
              <span className="ml-2">{user.email}</span>
            </div>

            <div className="flex">
              <span className="w-32 font-medium">Image URL</span>
              <span>:</span>
              <span className="ml-2 break-all text-blue-600">
                {user.image_url}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
